module.exports = __webpack_public_path__ + "static/media/article3sqr.7ea2995f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article3sqr.jpeg
// module id = 96
// module chunks = 0